export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('observe', {
    beforeMount(el, { value: observer }) {
      if (observer && observer.observe) {
        observer.observe(el)
      }
    }
  })
})
